import React, { useEffect, useState } from "react";
import { Modal, Button, Form, Input, Select, InputNumber } from "antd";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import axios from "../../../services/axiosConfig";
import Helper from "../../../services/Helper";

const Notes = ({ show, close, details }) => {
  const [form] = Form.useForm();
  const { TextArea } = Input;

  useEffect(() => {
    form.setFieldsValue({
      note: details.notes,
    });
  }, [show]);

  const handleCancel = () => {
    close();
  };

  const onFinish = async (values) => {
    const data = await axios
      .post("/update-order-img", {
        ordersId: details.id,
        notes: values.note,
      })
      .catch((error) => {
        Helper.ErrorHanlder(error);
      });
    if (data && data.data) close(data);
  };

  return (
    <>
      <Modal title="" open={show} onCancel={handleCancel} footer={false}>
        <Form layout={"vertical"} form={form} onFinish={onFinish}>
          <Form.Item label="Note" name="note">
            <ReactQuill theme="snow" />
          </Form.Item>
          <Form.Item className="popup-submit">
            <Button className="popup-cancel-btn" onClick={handleCancel}>
              Cancel
            </Button>
            <Button
              type="primary"
              htmlType="submit"
              className="popup-submit-btn"
            >
              Update
            </Button>
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
};

export default Notes;
